// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ReceiptsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /payroll/receipts
 *
 * Lists receipts for a payment rule execution. execution_id is read from the query string.
 */
import { registerContract } from './validate'

export interface Payroll_ReceiptsInput {
execution_id?: number
}

registerContract('Payroll_ReceiptsInput', {
  execution_id: { type: 'number',  required: false },
})
